<template>
  <div>
    <div v-if="object.include_payment_for_core_tariff">Тариф</div>
    <div v-if="object.paid_functionality_objects && object.paid_functionality_objects.length">{{ object.paid_functionality_objects.map(x => x.title).join(', ') }}</div>
    <div v-if="object.additional_services && object.additional_services.length">{{ object.additional_services.map(x => x.title).join(', ') }}</div>
    <div v-if="object.additional_doctors">Доп врачей: {{ object.additional_doctors }}</div>
    <div v-if="object.additional_space">Доп места: {{ object.additional_space * 100 }} Мб</div>
    <div v-if="object.additional_jet_api">Доп jet api: {{ object.additional_jet_api }}</div>
    <div v-if="object.additional_green_api">Доп green api: {{ object.additional_green_api }}</div>
    <div v-if="object.additional_partner_api">Доп партнерский api: {{ object.additional_partner_api }}</div>
  </div>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  },
})
</script>
